import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Row,
    Col,
    Card
} from 'reactstrap';
import styles from './styles.module.scss';
import Link from "next/link"

export default function AllSectors({
    global,
    pathPrefix,
    customClass = "",
    content,
    post,
    locale = ""
}) {
    return (
        <section className={`${styles.root} ${customClass} py-1`}>
            <Container>
                {content ?
                    <div className="mb-5 text-center">
                        <SourceFlowText global={global} path={`${pathPrefix}.content`} type="html">
                            {content}
                        </SourceFlowText>
                    </div> : null}
                <Row className="wrapper flex-wrap text-center">
                    {post?.map((post, index) => (
                        <Card key={index} className="bg-transparent border-0">
                            <div className="mb-4 overflow-hidden rounded-4">
                                <Link href={`${locale}${locale == "/us/" ? "markets" : "specialisms"}/${post.url_slug}`}>
                                    <a>
                                        <SourceFlowImage
                                            src={post.image ? post.image : "/site-assets/placeholders/img-placeholder.jpg"}
                                            size="800x800"
                                            alt={post?.title}
                                            className="card-img"
                                        />
                                    </a>
                                </Link>
                            </div>
                            <Link href={`${locale}${locale == "/us/" ? "markets" : "specialisms"}/${post.url_slug}`}>
                                <a>
                                    <p className="fs-5"><strong>{post?.title}</strong></p>
                                </a>
                            </Link>

                        </Card>
                    ))}
                </Row>
            </Container>
        </section>
    )
}